import styled from '@emotion/styled';
import media from '@shared/mediaQuery';
import { getStaticImageUrl } from '@utils/createImageUrl';

const FursysBenefit1Style = styled('div')`
  ${media.desktop} {
    width: 1080px;
    margin: auto;
  }

  .benfit {
    padding-top: 160px;
    font-family: 'Pretendard-Bold';
    font-size: 26px;
    letter-spacing: -0.3px;
    text-align: center;
    color: #c1b3ac;
    background: url(${getStaticImageUrl({ fileName: 'index-01.png' })}) right 455px top 124px no-repeat;
    background-size: 78px 62px;
    margin-bottom: 19px;
    ${media.desktop} {
      transform: translateX(-12px);
    }
    ${media.mobile} {
      padding-top: 89px;
      background: url(${getStaticImageUrl({ fileName: 'index-01.png' })}) right calc(50% - 26px) top 65px no-repeat;
      font-size: 16px;
      background-size: 49px 39px;
    }
  }

  .slidTitle {
    font-family: 'Pretendard-Bold';
    font-size: 38px;
    letter-spacing: -0.3px;
    text-align: center;
    color: #faeeec;
    ${media.desktop} {
      line-height: 52px;
      margin-bottom: 20px;
    }
    ${media.mobile} {
      font-size: 29px;
      line-height: 37px;
    }
  }

  .slideDescription {
    margin-top: 21px;
    margin-bottom: 37px;
    font-family: 'Pretendard-Regular';
    font-size: 18px;
    letter-spacing: -0.3px;
    text-align: center;
    color: #c1b3ac;
    ${media.mobile} {
      margin-top: 10px;
      margin-bottom: 27px;
      font-size: 14px;
      line-height: 20px;
    }
  }

  .fursysbrand {
    &--list {
      .slick-prev {
        &::before {
          display: none !important;
        }
      }
      .slick-next {
        &::before {
          display: none !important;
        }
      }
    }
    &--list-mobile {
      img {
        width: calc(100% - 40px);
        margin: auto;
        text-align: center;
      }
    }
    &--item {
      display: block !important;
    }
  }
  .slick-dots {
    ${media.mobile} {
      bottom: -21px;
      width: 100vw;
      padding: 0 20px;
      display: flex;
      justify-content: center;
      margin-left: -25px;
    }
    li {
      width: 10px;
      button:before {
        font-size: 30px;
        color: #ffffff;
      }
    }
  }

  .downloadButton {
    display: block;
    width: 247px;
    height: 45px;
    border: solid 1px #ff5500;
    margin: auto;
    text-align: center;
    font-family: 'Pretendard-Bold';
    font-size: 16px;
    letter-spacing: -0.3px;
    text-align: center;
    color: #ff5500;
    line-height: 45px;
    cursor: pointer;
    position: relative;
    margin-bottom: 47px;
    ${media.mobile} {
      margin-bottom: 37px;
      width: 197px;
      height: 38px;
      line-height: 38px;
      font-size: 12px;
    }
  }
`;

export default FursysBenefit1Style;
